import React, { lazy } from 'react';
export function Map() {
  return <section className="pb-24 bg-white" data-id="element-75">
      <div className="container mx-auto px-6" data-id="element-76">
        <div className="w-full h-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-lg border border-mimate-primary/10" data-id="element-77">
          <iframe src="https://maps.google.com/maps?q=Plaza+Misiones+de+la+Noria,+Prolongaci%C3%B3n+Ignacio+Aldama+188,+San+Juan+Tepepan,+Xochimilco,+CDMX&t=&z=18&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Mímate Studio" data-id="element-78"></iframe>
        </div>
      </div>
    </section>;
}